// @flow

import type { SelectNativeOption } from 'reshaped';

type Props = SelectNativeOption;

export function Option({ label, value, disabled }: Props): React.MixedElement {
  return (
    <option value={value} disabled={disabled}>
      {label}
    </option>
  );
}
